import React from "react";
import * as Animate from "react-reveal";
import ButtonLink from "../../components/elements/ButtonLink";

import BeginImage from "../../assets/images/png/individual/beginImage.png";

const BeginSection = ({
  title,
  description,
  btnLink,
  btnTitle,
  image,
  isExternalLink,
}) => {
  return (
    <section className="individual-begin-section">
      <div className="mx-auto">
        <div className="relative flex flex-row flex-wrap justify-between">
          <div className="pl-6 md:pl-20 lg:pl-28 xl:pl-32 pr-6 lg:pr-0 pt-16 pb-16 xl:pb-0 w-full lg:w-8/12 xl:w-6/12 ">
            <Animate.Fade bottom>
              <h2 className="text-white text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold w-full lg:w-11/12 pr-4">
                {title || (
                  <>
                    Begin your tech journey{" "}
                    <span className="text-gradient">with Utiva</span>
                  </>
                )}
              </h2>

              <p className="mt-6 lg:mt-8 text-white text-base lg:text-lg xl:text-xl lg:leading-7 w-full lg:w-10/12">
                {description ||
                  `Utiva Platform = Intuitive + Powered by Analytics =
                Collaborative Learning.`}
              </p>

              <div className="mt-8 lg:mt-12">
                <ButtonLink
                  isExternalLink={isExternalLink}
                  withDropShadow={false}
                  title={btnTitle || "Start Now"}
                  url={btnLink || "/school"}
                />
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:w-5/12 hidden xl:block relative h-full">
            <img
              src={image || BeginImage}
              className="h-full object-cover"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeginSection;
